import type { OrganizationRole, Role, User } from '@/api/types';

/**
 * SuperAdmin is the only global role left - everything else (managing an
 * organization, judging or entering a competition) is scoped per
 * org/competition and resolved via hooks/useActiveCompetitionRole.ts instead
 * of a flat role check.
 */
export function hasRole(user: User | null | undefined, ...roles: Role[]): boolean {
  if (!user) return false;
  return user.roles?.some((r) => roles.includes(r)) ?? false;
}

export function isSuperAdmin(user: User | null | undefined): boolean {
  return hasRole(user, 'SuperAdmin');
}

export function organizationRoleLabel(role: OrganizationRole): string {
  switch (role) {
    case 'OrganizationAdmin':
      return 'Skrbnik organizacije';
    case 'Organizer':
      return 'Organizator';
    default:
      return role;
  }
}
